<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.csd', 2) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md12 v-if="csd.rfc">
                <h4>RFC: {{ csd.rfc }}</h4>
                <h4>{{ $t('uploadDate') }}: {{ csd.upload_date | date('YYYY-MM-DD') }}</h4>
                <h4>{{ $t('expirationDate') }}: {{ csd.expiration_date | date('YYYY-MM-DD') }}</h4>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field :label="$t('selectFile')" @click="pickCertFile" v-model="certFilename" prepend-icon="attach_file"></v-text-field>
                <input type="file" style="display: none" ref="certFile" accept=".cer" @change="onCertFilePicked">
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field :label="$t('selectFile')" @click="pickKeyFile" v-model="keyFilename" prepend-icon="attach_file"></v-text-field>
                <input type="file" style="display: none" ref="keyFile" accept=".key" @change="onKeyFilePicked">
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field :label="$t('attrs.password')" v-model="password"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save" :loading="loading" :disabled="loading"> {{ $t('save') }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Csd from '@/client/csd'

export default {
  name: 'CSDsView',

  props: {},

  data () {
    return {
      csd: {},
      password: '',
      certFilename: '',
      certInputFile: '',
      keyFilename: '',
      keyInputFile: '',
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetchCsd() {
      this.csd = await Csd.findOne()
    },

    onCertFilePicked (e) {
      this.loading = true
      this.errors.clear()

      this.certInputFile = e.target.files[0]
      this.certFilename = this.certInputFile.name
      this.loading = false
    },

    pickCertFile () {
      this.$refs.certFile.click()
    },

    onKeyFilePicked (e) {
      this.loading = true
      this.errors.clear()

      this.keyInputFile = e.target.files[0]
      this.keyFilename = this.keyInputFile.name
      this.loading = false
    },

    pickKeyFile () {
      this.$refs.keyFile.click()
    },

    async save () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        const formData = new FormData()
        formData.append('csd[certificate]', this.certInputFile)
        formData.append('csd[private_key]', this.keyInputFile)
        formData.append('csd[password]', this.password)
        await Csd.import(formData)
        this.setNotification({
          color: 'success',
          message: 'Archivos importados correctamente!'
        })
        this.fetchCsd()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
    this.fetchCsd()
  }
}
</script>
